import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import PortalTopBar from '../../components/academy/PortalTopBar';

const LINKS = [
  { label: 'Browse all programs', href: '/academy/programs', desc: 'The full ZHELTA Academy catalog — 11 programs.' },
  { label: 'Visit ZHELTA Systems', href: '/systems', desc: 'Our enterprise IT services division.' },
  { label: 'About ZHELTA', href: '/about', desc: 'Company history, leadership and mission.' },
  { label: 'Contact support', href: 'mailto:careers@zhelta.com', desc: 'Email the Academy team directly.' },
  { label: 'Main ZHELTA site', href: '/', desc: 'Homepage for the wider ZHELTA company.' },
];

export default function HelpfulLinks() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <PortalTopBar />
      <main className="max-w-[900px] mx-auto px-4 lg:px-6 py-8">
        <Link to="/academy/dashboard" className="inline-flex items-center gap-1.5 text-[13px] text-[#6E6E73] hover:text-[#c9a227] mb-4">
          <ArrowLeft className="w-3.5 h-3.5" /> Dashboard
        </Link>
        <h1 className="text-[28px] font-extrabold text-[#1D1D1F] mb-1">Helpful Links</h1>
        <p className="text-[14px] text-[#6E6E73] mb-6">Quick access to the resources you'll need most often.</p>

        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {LINKS.map((l) => {
            const external = l.href.startsWith('http') || l.href.startsWith('mailto:');
            return (
              <li key={l.href}>
                <a
                  href={l.href}
                  target={external && l.href.startsWith('http') ? '_blank' : undefined}
                  rel={external ? 'noopener noreferrer' : undefined}
                  data-testid={`helpful-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="block p-5 rounded-2xl border border-[#E5E5E7] bg-white hover:border-[#c9a227] hover:shadow-md transition-all"
                >
                  <div className="flex items-start justify-between gap-3 mb-1.5">
                    <h3 className="text-[16px] font-extrabold text-[#1D1D1F] group-hover:text-[#c9a227]">{l.label}</h3>
                    <ExternalLink className="w-4 h-4 text-[#c9a227] shrink-0" />
                  </div>
                  <p className="text-[13px] text-[#6E6E73]">{l.desc}</p>
                </a>
              </li>
            );
          })}
        </ul>
      </main>
    </div>
  );
}
